// tslint:disable-next-line:only-arrow-functions
const URL_API = ( function() {
  if ( location.hostname === 'localhost') {
    //return 'http://localhost:81'
    return 'https://regis.theappsonline.com/api'
  } else {
    //return 'http://localhost/api'
    return 'https://regis.theappsonline.com/api'
  }
})();

// tslint:disable-next-line:only-arrow-functions
const URL_WWW = ( function() {
  if ( location.hostname === 'localhost') {
    return 'https://localhost:8080/'
  } else {
    return 'https:/ionel.theappsonline.com/'
  }
})();

export const CONFIG_ENV = {

  URL_USER: {
    getUser : URL_API + '/user/user',
  },
  URL_NOM: {
    categorie : URL_API + '/nom_categ/categorie',
    categorii : URL_API + '/nom_categ/categorii',
    tip_doc : URL_API + '/nom_tip_doc/tip_doc',
    tip_docs : URL_API + '/nom_tip_doc/tip_docs',
    registru : URL_API + '/nom_registre/registru',
    registre : URL_API + '/nom_registre/registre',
    hr_nom_org: URL_API + '/nom_hr/org',
  } ,
  URL_DOCUMENT: {
    doc_intrare : URL_API + '/documente/doc_intrare',
    qr_code : URL_API + '/documente/qr_code',
    pdf_cover : URL_API + '/documente/pdf_cover',
    MyDocuments : URL_API + '/documente/my_documents',
    MyDocumentsWithNoScan : URL_API + '/documente/docs_fara_scan',
    FastSearch : URL_API + '/documente/fast_search',
  } ,
  URL_SCAN: {
    uploadScan : URL_API + '/scan/upload',
    getScans : URL_API + '/scan/scans',
    getInfoScan : URL_API + '/scan/info',
  } ,
  URL_NOMENCLATURES: {
    get_nom_categ_of_events : URL_API + 'nomenclatures/nom_categ_of_events',
    get_nom_types_of_events : URL_API + 'nomenclatures/nom_types_of_events',
  },
  URL_PUBLIC_INFO: {
    get_last_public_lists : URL_API + 'publicinfo/get_last_public_lists',
    get_last50_public_lists : URL_API + 'publicinfo/get_last50_public_lists',
    get_last50_public_gift_ideas : URL_API + 'publicinfo/get_last50_public_gift_ideas',
    get_list_details : URL_API + 'publicinfo/get_list_details',
    get_list_gifts : URL_API + 'publicinfo/get_list_gifts',
    get_gift : URL_API + 'publicinfo/get_gift',
    get_list_partakers : URL_API + 'publicinfo/get_list_partakers',
    getImageAsAvatarForGift : URL_API + 'publicinfo/get_image_as_avatar_for_gift',
  },
  URL_PRIVATE_INFO: {
    get_list_details: URL_API + 'privateinfo/get_list_details',
    check_token_for_private_list: URL_API + 'privateinfo/check_token_for_private_list',
  },
  myLocale: {
    /* starting with Sunday */
    days: 'Duminica_Luni_Marti_Miercuri_Joi_Vineri_Sambata'.split('_'),
    daysShort: 'Dum_Lun_Mar_Mie_Joi_Vie_Sam'.split('_'),
    months: 'Ianuarie_Februarie_Martie_Aprilie_Mai_Iunie_Iulie_August_Septembrie_Octombrie_Noiembrie_Decembrie'.split('_'),
    monthsShort: 'Ian_Feb_Mar_Apr_Mai_Iun_Iul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    firstDayOfWeek: 1
  }
}
